import { EmailSchema } from './Email.type'
import { object, type InferOutput } from 'valibot'

export const OtpRequestSchema = object({
  email: EmailSchema,
})

export type OtpRequest = InferOutput<typeof OtpRequestSchema>
